import { render, staticRenderFns } from "./openInventory.vue?vue&type=template&id=9b3858b2&scoped=true"
import script from "./openInventory.vue?vue&type=script&lang=js"
export * from "./openInventory.vue?vue&type=script&lang=js"
import style0 from "./openInventory.vue?vue&type=style&index=0&id=9b3858b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3858b2",
  null
  
)

export default component.exports